import { _BaseSectionButtonData, ISectionButtonData, sectionButtonData } from "./_base-section-button"

export class SectionButtonDelete 
    extends _BaseSectionButtonData
{
    protected constructor(buttonData?: ISectionButtonData){
        super(buttonData);

        this[sectionButtonData.disabled] = false;
        this[sectionButtonData.hide] = null;
    }

    static create(buttonData?: ISectionButtonData) {
        return !!buttonData ? new SectionButtonDelete(buttonData) : null;
    }
}
